import { OmfCalculator } from './omf/calculator/offerBounds.mjs';

/**
 * @param {number} loanTerm - loan term to get a loan for
 * @param {number} loanAmount - loan amount to get a loan for
 * @param {object} config - loan config object
 * @param {number} config.minimumInitiationFee - minimum initiation fee (without VAT)
 * @param {number} config.maximumInitiationFee - maximum initiation fee (without VAT)
 * @param {number} config.vatRate - current vat rate (as a percentage)
 * @param {number} config.interestRate - loan interest rate (as a percentage)
 * @param {number} config.interestRateOMF - loan interest rate for OMF (as a percentage)
 * @param {number} config.creditLifeRate - loan credit life rate (as a percentage)
 * @param {number} config.adminFee - monthly static adminFee
 * @returns {{
 * principal: number,
 * loanTerm: number,
 * initiationFee: number,
 * creditLifeInsurance: number,
 * installment: number,
 * loanAmount: number
 * }} - calculated details of the loan
 */
export function getLoan(loanTerm, loanAmount, {
  minimumInitiationFee, maximumInitiationFee, vatRate,
  interestRate, interestRateOMF, creditLifeRate, adminFee,
}) {
  const omfCalculator = new OmfCalculator(minimumInitiationFee, maximumInitiationFee, vatRate);
  const principal = omfCalculator.getPrincipal(loanAmount);
  if (interestRateOMF) {
    interestRate = interestRateOMF;
  }

  const installment = -omfCalculator.getDeduction(principal, 0, interestRate, loanTerm, creditLifeRate, adminFee);
  const creditLifeInsurance = omfCalculator.getCreditLifeFee(principal, creditLifeRate);
  const initiationFee = omfCalculator.getInitiationFee(loanAmount);
  return {
    principal,
    loanTerm,
    loanAmount,
    installment,
    creditLifeInsurance,
    initiationFee,
    interestRate,
  };
}
